
import React from 'react'
import { Link } from 'react-router-dom'

interface Props {
  active: boolean
  disabled: boolean
  icon: string
  text: string
  path: string
  itemWidth?: number
}

const HeaderSubmenuItem = ({ active, disabled, icon, text, path, itemWidth }: Props) => {

  const itemStyle = itemWidth ? ({
    '--pl4-submenu-item-width': `${itemWidth}px`
  } as React.CSSProperties) : undefined

  return (
    <li>
      {disabled ? (
        <span className={`submenu-span ${!active ? '' : 'active'}`} style={itemStyle}>
          <span className="submenu-icon">
            <div className="svg-icon-menu" style={{
              display: 'inline-block',
            }}>
              <div className="svg-icon-container">
                <span className={`${icon}${active ? '_full' : ''}`}></span>
              </div>
            </div>
          </span>
          <span className="d-none d-md-inline">{text}</span>
        </span>
      ) : (
        <Link className={`submenu-link ${!active ? '' : 'active'}`} to={path} style={itemStyle}>
          <span className="submenu-icon">
            <div className="svg-icon-menu" style={{
              display: 'inline-block',
            }}>
              <div className="svg-icon-container">
                <span className={`${icon}${active ? '_full' : ''}`}></span>
              </div>
            </div>
          </span>
          <span className="d-none d-md-inline">{text}</span>
        </Link>
      )}
    </li>
  )
}

export default HeaderSubmenuItem
